import { PAGE_PERMISSION_CODES, PERMISSION_CODES } from '@core-ui/common';
import type {
    AppModule,
    AppSubmodule,
    ExposedMenu,
    SideLink,
} from '@moniebook-web/components/widgets/sidebar';
import { Settings } from '@moniebook-web/icons/sidebar-rail/settings';
import { Settings3Fill } from '@moniebook-web/icons/system/settings-3-fill';
import {
    useMobileMenuStore,
    useMobileSettingsMenuStore,
} from '@moniebook-web/store';
import {
    ApplicationModule,
    MENU_SECTIONS,
    PAGES,
    SETTINGS_SECTIONS,
} from '@moniebook-web/types';

export const settingsMenu: ExposedMenu = {
    menuGroups: [],
    submenu: [
        {
            sectionId: MENU_SECTIONS.NONE,
            order: 7,
            name: 'Settings',
            to: '',
            icon: <Settings3Fill />,
            onClick: ({ navigate, screenSize }) => {
                const isDesktop = !['sm', 'md', 'lg'].includes(screenSize);

                if (isDesktop) {
                    return navigate(PAGES.SETTINGS);
                }

                useMobileMenuStore.setState({ show: false });
                useMobileSettingsMenuStore.setState({ show: true });
            },
        },
        {
            sectionId: SETTINGS_SECTIONS.SETTINGS,
            name: 'Account details',
            to: '/dashboard/settings/personal',
            order: 1,
            showInSettings: true,
            featureFlag: 'hiddenFeature',
        },
        {
            sectionId: SETTINGS_SECTIONS.SETTINGS,
            name: 'Security',
            to: '/dashboard/settings/change-password',
            order: 2,
            showInSettings: true,
            featureFlag: 'hiddenFeature',
        },
        {
            sectionId: SETTINGS_SECTIONS.BUSINESS,
            name: 'Business information',
            to: '/dashboard/settings/business',
            order: 1,
            accessCodeList: PAGE_PERMISSION_CODES.BUSINESS,
            showInSettings: true,
        },
        {
            sectionId: SETTINGS_SECTIONS.BUSINESS,
            name: 'Preferences',
            to: '/dashboard/settings/preferences',
            order: 2,
            showInSettings: true,
            featureFlag: 'moniebook.pos.enableUserTimeZonePreference',
        },
        {
            sectionId: SETTINGS_SECTIONS.BUSINESS,
            name: 'Billing & Subscriptions',
            to: '/dashboard/settings/subscriptions',
            order: 3,
            accessCodeList: [PERMISSION_CODES.MANAGE_SUBSCRIPTION],
            showInSettings: true,
        },
        {
            sectionId: SETTINGS_SECTIONS.SALES,
            order: 2,
            name: 'Payment methods',
            to: '/dashboard/settings/payment-methods',
            accessCodeList: [PERMISSION_CODES.MANAGE_PAYMENT_METHOD],
            showInSettings: true,
        },
    ] as SideLink[],
    modules: [
        {
            id: ApplicationModule.SETTINGS,
            order: 9,
            name: 'Settings',
            railSection: 'bottom',
            to: PAGES.SETTINGS,
            icon: <Settings />,
            foregroundColor: '#1d1f2699',
            backgroundColor: '#F0F1F4',
            onClick: ({ navigate, screenSize }) => {
                const isDesktop = !['sm', 'md', 'lg'].includes(screenSize);

                if (isDesktop) {
                    return navigate(PAGES.SETTINGS);
                }

                useMobileMenuStore.setState({ show: false });
                useMobileSettingsMenuStore.setState({ show: true });
            },
        },
    ] as AppModule[],
    subModules: [
        {
            sectionId: SETTINGS_SECTIONS.SETTINGS,
            name: 'Account details',
            to: '/dashboard/settings/personal',
            order: 1,
            showInSettings: true,
            featureFlag: 'hiddenFeature',
        },
        {
            sectionId: SETTINGS_SECTIONS.SETTINGS,
            name: 'Security',
            to: '/dashboard/settings/change-password',
            order: 2,
            showInSettings: true,
            featureFlag: 'hiddenFeature',
        },
        {
            sectionId: SETTINGS_SECTIONS.BUSINESS,
            name: 'Business information',
            to: '/dashboard/settings/business',
            order: 1,
            accessCodeList: PAGE_PERMISSION_CODES.BUSINESS,
            showInSettings: true,
        },
        {
            sectionId: SETTINGS_SECTIONS.BUSINESS,
            name: 'Preferences',
            to: '/dashboard/settings/preferences',
            order: 2,
            showInSettings: true,
            featureFlag: 'moniebook.pos.enableUserTimeZonePreference',
        },
        {
            sectionId: SETTINGS_SECTIONS.BUSINESS,
            name: 'Billing & Subscriptions',
            to: '/dashboard/settings/subscriptions',
            order: 3,
            accessCodeList: [PERMISSION_CODES.MANAGE_SUBSCRIPTION],
            showInSettings: true,
        },
        {
            sectionId: SETTINGS_SECTIONS.SALES,
            order: 2,
            name: 'Payment methods',
            to: '/dashboard/settings/payment-methods',
            accessCodeList: [PERMISSION_CODES.MANAGE_PAYMENT_METHOD],
            showInSettings: true,
        },
    ] as AppSubmodule[],
};
